import React from 'react';
import { Alert, Button } from '@themesberg/react-bootstrap';
import Swal from 'sweetalert2';

export default class FeatureErrorBoundary extends React.Component {
    state = { failed: false };
    static getDerivedStateFromError() { return { failed: true }; }
    componentDidCatch(error) {
        // A page may have opened a portal-based loading modal before crashing.
        // It lives outside the failed React subtree, so explicitly release it.
        try { if (Swal.isLoading()) Swal.close(); } catch { /* Keep the recovery UI usable. */ }
        // Do not log props: they may contain credentials or tokens.
        console.error(`[GeoNow] ${this.props.name || '頁面'}元件發生錯誤：${error.name}`);
    }
    componentDidUpdate(previous) {
        if (this.state.failed && previous.resetKey !== this.props.resetKey) this.setState({ failed: false });
    }
    render() {
        if (!this.state.failed) return this.props.children;
        return <Alert variant="warning" role="alert">
            <p>{this.props.name || '此頁面'}暫時無法顯示。你仍可切換專案或使用其他功能。</p>
            <Button size="sm" variant="outline-primary" onClick={() => this.setState({ failed: false })}>重試</Button>
        </Alert>;
    }
}
